import * as Yup from 'yup';

export const formConstants = {
  docaiFilterWhitelistSuppliers: {
    name: 'docaiFilterWhitelistSuppliers',
    label: 'Whitelist Emails from Recognized Suppliers',
    description:
      'If enabled, emails that contain a domain associated with a Supplier configured in Cofactr will be processed by DocAI',
  },
  docaiFilterDomainWhitelist: {
    name: 'docaiFilterDomainWhitelist',
    label: 'Whitelist Domains',
    description:
      'Emails that contain a domain in this list will be processed by DocAI',
  },
  docaiFilterDomainBlacklist: {
    name: 'docaiFilterDomainBlacklist',
    label: 'Blacklist Domains',
    description:
      'Emails that contain a domain in this list will be ignored by DocAI',
  },
  docaiFilterSubjectRegexWhitelist: {
    name: 'docaiFilterSubjectRegexWhitelist',
    label: 'Subject Regex Whitelist',
    description:
      'Emails where the subject line matches a regex pattern in this list will be processed by DocAI',
  },
  docaiFilterSubjectRegexBlacklist: {
    name: 'docaiFilterSubjectRegexBlacklist',
    label: 'Subject Regex Blacklist',
    description:
      'Emails where the subject line matches a regex pattern in this list will be ignored by DocAI',
  },
  docaiFilterBodyRegexWhitelist: {
    name: 'docaiFilterBodyRegexWhitelist',
    label: 'Body Regex Whitelist',
    description:
      'Emails where the body matches a regex pattern in this list will be processed by DocAI',
  },
  docaiFilterBodyRegexBlacklist: {
    name: 'docaiFilterBodyRegexBlacklist',
    label: 'Body Regex Blacklist',
    description:
      'Emails where the body matches a regex pattern in this list will be ignored by DocAI',
  },
  docaiFilterAllowIfRecordMatches: {
    name: 'docaiFilterAllowIfRecordMatches',
    label: 'Allow if Record Matches',
    description:
      'If enabled, emails that contain a PO or Order number associated with an open Purchase Order in Cofactr will be processed by DocAI',
  },
  docaiFilterIgnoreIfRecordNotMatched: {
    name: 'docaiFilterIgnoreIfRecordNotMatched',
    label: 'Ignore if Record Not Matched',
    description:
      'If enabled, emails that do not contain a PO or Order number associated with an open Purchase Order in Cofactr will be ignored by DocAI',
  },
};

const isValidRegex = (value: string) => {
  try {
    RegExp(value);
    return true;
  } catch (e) {
    return false;
  }
};

export const formValidation = Yup.object().shape({
  [formConstants.docaiFilterWhitelistSuppliers.name]: Yup.boolean(),
  [formConstants.docaiFilterDomainWhitelist.name]: Yup.array().of(
    Yup.string().matches(
      /^(?!:\/\/)(?=.{1,253}(?:\.|$))(?!-)[a-zA-Z0-9-]{1,63}(?<!-)(?:\.(?!-)[a-zA-Z0-9-]{1,63}(?<!-))*(?:\.[a-zA-Z]{2,})?$/,
      'Invalid domain name format'
    )
  ),
  [formConstants.docaiFilterDomainBlacklist.name]: Yup.array().of(
    Yup.string().matches(
      /^(?!:\/\/)(?=.{1,253}(?:\.|$))(?!-)[a-zA-Z0-9-]{1,63}(?<!-)(?:\.(?!-)[a-zA-Z0-9-]{1,63}(?<!-))*(?:\.[a-zA-Z]{2,})?$/,
      'Invalid domain name format'
    )
  ),
  [formConstants.docaiFilterSubjectRegexWhitelist.name]: Yup.array().of(
    Yup.string().test('is-valid-regex', 'Invalid regex pattern', (value) => {
      if (value === undefined || value === null) return true;
      return isValidRegex(value);
    })
  ),
  [formConstants.docaiFilterSubjectRegexBlacklist.name]: Yup.array().of(
    Yup.string().test('is-valid-regex', 'Invalid regex pattern', (value) => {
      if (value === undefined || value === null) return true;
      return isValidRegex(value);
    })
  ),
  [formConstants.docaiFilterBodyRegexWhitelist.name]: Yup.array().of(
    Yup.string().test('is-valid-regex', 'Invalid regex pattern', (value) => {
      if (value === undefined || value === null) return true;
      return isValidRegex(value);
    })
  ),
  [formConstants.docaiFilterBodyRegexBlacklist.name]: Yup.array().of(
    Yup.string().test('is-valid-regex', 'Invalid regex pattern', (value) => {
      if (value === undefined || value === null) return true;
      return isValidRegex(value);
    })
  ),
  [formConstants.docaiFilterAllowIfRecordMatches.name]: Yup.boolean(),
  [formConstants.docaiFilterIgnoreIfRecordNotMatched.name]: Yup.boolean(),
});
